import React from "react";
import { Container, Box, Breadcrumbs, Typography, Link as MUILink } from "@mui/material";

export default function PageContainer({ title, breadcrumbs, children, actions }) {
    return (
        <Container maxWidth="xl" sx={{ py: 4 }}>
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
                <Box>
                    {breadcrumbs && (
                        <Breadcrumbs sx={{ mb: .5 }}>
                            {breadcrumbs.map((b, i) => (
                                <MUILink key={i} underline="hover" color={i === breadcrumbs.length - 1 ? 'text.primary' : 'inherit'}>
                                    {b}
                                </MUILink>
                            ))}
                        </Breadcrumbs>
                    )}
                    <Typography variant="h4" sx={{ fontWeight: 800 }}>{title}</Typography>
                </Box>
                <Box>{actions}</Box>
            </Box>
            {children}
        </Container>
    );
}
